skrilla.service('currencyService', function() {

    var currencies = ["USD", "AUD", "NZD", "EUR", "CAD"];
    var currencyMap = {
        "AUD": true, //checked by default
        "USD": false,
        "NZD": false,
        "EUR": false,
        "CAD": false
    };

    function getCurrencyAmount(currency){
        switch(currency){
            case "CAD":
                return 100;
                break;
            case "AUD":
                return 100;
                break;
            case "NZD":
                return 100;
                break;
            case "USD":
                return 100;
                break;
            case "EUR":
                return 100;
                break;
            default:
                return 100;
                break;
        }
    }

    function multiply(amount, currency){
        return new BigNumber(amount).multipliedBy(getCurrencyAmount(currency)).toNumber();
    }

    function divide(amount, currency){
        return new BigNumber(amount).dividedBy(getCurrencyAmount(currency)).toNumber();
    }

    function getCurrencies(){
        return currencies;
    }
    function getCurrencyMap(){
        return currencyMap;
    }

    return {
        getCurrencyAmount: getCurrencyAmount,
        getCurrencyMap: getCurrencyMap,
        getCurrencies: getCurrencies,
        multiply: multiply,
        divide: divide
    };
});
